import React, { useEffect, useState } from "react";
import api from '../../api/axiosInstance';
import AdminLayout from "../../components/admin/AdminLayout";
import { Button, Badge, Modal } from "react-bootstrap";

const AdminMessages = () => {
  const [messages, setMessages] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [page, setPage] = useState(1);

  // Modal
  const [show, setShow] = useState(false);
  const [selectedMsg, setSelectedMsg] = useState(null);

  const openModal = (msg) => {
    setSelectedMsg(msg);
    setShow(true);
  };

  const closeModal = () => {
    setSelectedMsg(null);
    setShow(false);
  };

  const loadMessages = async (pageNum = 1) => {
    const token = localStorage.getItem("token");

    const res = await api.get(
      `/contact?page=${pageNum}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    setMessages(res.data.messages);
    setTotalPages(res.data.totalPages);
    setPage(res.data.page);
  };

  useEffect(() => {
    loadMessages();
  }, []);

  // OKUNDU / OKUNMADI
  const toggleRead = async (id) => {
    const token = localStorage.getItem("token");

    await api.patch(
      `/contact/${id}/read`,
      {},
      { headers: { Authorization: `Bearer ${token}` } }
    );

    loadMessages(page);

    // Modal açıksa modal içindeki durumu güncelle
    if (selectedMsg && selectedMsg._id === id) {
      setSelectedMsg({
        ...selectedMsg,
        isRead: !selectedMsg.isRead,
      });
    }
  };

  // SİLME
  const deleteMsg = async (id) => {
    if (!window.confirm("Mesaj silinsin mi?")) return;

    const token = localStorage.getItem("token");

    await api.delete(`/contact/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    loadMessages(page);
    closeModal();
  };

  return (
    <AdminLayout>
      <h2>📩 İletişim Mesajları</h2>

      <table className="table mt-3">
        <thead>
          <tr>
            <th>Gönderen</th>
            <th>E-posta</th>
            <th>Mesaj</th>
            <th>Tarih</th>
            <th>Durum</th>
            <th>İşlem</th>
          </tr>
        </thead>

        <tbody>
          {messages.map((m) => (
            <tr key={m._id}>
              <td>{m.name}</td>
              <td>{m.email}</td>

              {/* Mesaj kısaltma + modal açma */}
              <td
                onClick={() => openModal(m)}
                style={{
                  maxWidth: "250px",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  cursor: "pointer",
                  color: "#2D8A7A",
                  fontWeight: 500,
                }}
              >
                {m.message}
              </td>

              <td>{new Date(m.createdAt).toLocaleString("tr-TR")}</td>

              <td>
                {m.isRead ? (
                  <Badge bg="success">Okundu</Badge>
                ) : (
                  <Badge bg="warning" text="dark">
                    Okunmadı
                  </Badge>
                )}
              </td>

              <td>
                <Button
                  size="sm"
                  className="me-2"
                  variant={m.isRead ? "secondary" : "success"}
                  onClick={() => toggleRead(m._id)}
                >
                  {m.isRead ? "Okunmadı Yap" : "Okundu Yap"}
                </Button>

                <Button
                  size="sm"
                  variant="danger"
                  onClick={() => deleteMsg(m._id)}
                >
                  Sil
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Pagination Controls */}
      <div className="d-flex justify-content-center mt-3 gap-2">
        <Button disabled={page <= 1} onClick={() => loadMessages(page - 1)}>
          ‹ Önceki
        </Button>

        <span className="px-3 py-2">
          Sayfa {page} / {totalPages}
        </span>

        <Button
          disabled={page >= totalPages}
          onClick={() => loadMessages(page + 1)}
        >
          Sonraki ›
        </Button>
      </div>

      {/* MODAL DETAY */}
      <Modal show={show} onHide={closeModal} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>📨 Mesaj Detayı</Modal.Title>
        </Modal.Header>

<Modal.Body>
  {selectedMsg && (
    <>
      <p>
        <strong>Ad Soyad:</strong> {selectedMsg.name}
      </p>
      <p>
        <strong>E-posta:</strong> {selectedMsg.email}
      </p>
      <p>
        <strong>Tarih:</strong>{" "}
        {new Date(selectedMsg.createdAt).toLocaleString("tr-TR")}
      </p>

      <hr />

      {/* 🟢 SATIR KIRAN VE TAŞMAYI DURDURAN MESAJ ALANI */}
      <p
        style={{
          whiteSpace: "pre-wrap",
          wordWrap: "break-word",
          overflowWrap: "break-word",
          lineHeight: "1.6",
        }}
      >
        {selectedMsg.message}
      </p>
    </>
  )}
</Modal.Body>


        <Modal.Footer>
          {selectedMsg && (
            <>
              <Button
                variant={selectedMsg.isRead ? "warning" : "success"}
                onClick={() => toggleRead(selectedMsg._id)}
              >
                {selectedMsg.isRead ? "Okunmadı Yap" : "Okundu Yap"}
              </Button>

              <Button variant="danger" onClick={() => deleteMsg(selectedMsg._id)}>
                Sil
              </Button>
            </>
          )}

          <Button variant="secondary" onClick={closeModal}>
            Kapat
          </Button>
        </Modal.Footer>
      </Modal>
    </AdminLayout>
  );
};

export default AdminMessages;
